export enum LanguageCodes {
    French = "fr",
    English = "en",
    Spanish = "es"
};

export const LanguageStrings = {
    [LanguageCodes.English]: "English",
    [LanguageCodes.French]: "Français",
    [LanguageCodes.Spanish]: "Español"
}


// WEBPACK FOOTER //
// ./src/constants/languages.ts